<template>
  <div
    class="fb-share-button btn btn-facebook rounded-pill"
    :data-href="url ? url : fallbackUrl"
    data-layout="button"
    data-size="large"
    @click.prevent="share"
  >
    <i
      class="mi-facebook icon-24"
      :class="{'my-n2': !iconOnly}"
    />
    <span
      v-if="!iconOnly"
      class="block flex-grow-1"
    >{{ t('share_on_facebook') }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { noop, useScriptTag } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  iconOnly: {
    type: Boolean,
    default: false
  }
})

const { t } = useI18n()
const route = useRoute()

const base_url = computed(() => {
  const baseUrl = import.meta.env.VITE_VUE_APP_ORIGINAL_URL
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
})

const fallbackUrl = computed(() => {
  return `${base_url.value}${route.fullPath}`
})

useScriptTag(
  `https://connect.facebook.net/cs_CZ/sdk.js#xfbml=1&version=v10.0&appId=${
    import.meta.env.VITE_VUE_APP_FACEBOOK_APP_ID
  }&autoLogAppEvents=1`,
  noop,
  {
    crossorigin: 'anonymous',
    async: true,
    defer: true,
  }
)

const share = () => {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${props.url}&amp;src=sdkpreparse`,
    'share',
    'width=650,height=650'
  )
}
</script>

<i18n>
  {
    "cs": {
    "share_on_facebook": "Sdílet na Facebooku"
},
    "sk": {
    "share_on_facebook": "Zdieľať na Facebooku"
},
    "pl": {
    "share_on_facebook": "Udostępnij na Facebooku"
},
    "hu": {
    "share_on_facebook": "Megosztás Facebookon"
},
    "de": {
    "share_on_facebook": "Auf Facebook teilen"
},
    "at": {
    "share_on_facebook": "Auf Facebook teilen"
},
    "ro": {
    "share_on_facebook": "Distribuie pe Facebook"
},
    "fr": {
    "share_on_facebook": "Partager sur Facebook"
},
    "it": {
    "share_on_facebook": "Condividi su Facebook"
}
  }
</i18n>